import {useEffect} from "react";
import {useForm, Controller} from "react-hook-form";
import {ModalForm} from "~/components";
import {TextAreaField} from "~/components/Forms";

const nf = (n) => Number(n || 0).toLocaleString('vi-VN');

/**
 * Modal gửi yêu cầu mua Gói Extra (mua thêm hạn mức — vd bài viết AI tự động).
 * Không có cổng thanh toán: admin xác nhận thanh toán thủ công rồi duyệt đơn.
 */
function ExtraPurchaseModal({open, pack, submitting, onCancel, onSubmit}) {

	const {control, handleSubmit, reset, formState: {errors}} = useForm({defaultValues: {note: ''}});

	useEffect(() => {
		if (open) reset({note: ''});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open]);

	return (
		<ModalForm
			open={open}
			icon="fa-light fa-cart-plus"
			title={`Mua ${pack?.name || ''} — ${nf(pack?.price)}đ`}
			subtitle={`Cộng thêm ${nf(pack?.units)} ${pack?.metric_label || 'bài viết AI'}, dùng đến hết tháng được cấp. Quản trị viên sẽ xác nhận thanh toán và cộng bài cho bạn.`}
			onCancel={onCancel}
			onOk={handleSubmit(onSubmit)}
			okText="Gửi yêu cầu mua"
			loading={submitting}
		>
			<Controller control={control} name="note" render={({field}) => (
				<TextAreaField
					label="Lời nhắn (tuỳ chọn)"
					placeholder="VD: số điện thoại/Zalo để liên hệ, đã chuyển khoản lúc..."
					rows={4}
					errors={errors}
					{...field}
				/>
			)} />
		</ModalForm>
	);
}

export default ExtraPurchaseModal;
